import React from 'react';
import { HStack, Button } from '@chakra-ui/react';

/**
 * The chat-list filter row, the way WhatsApp draws it under the search field.
 *
 * WhatsApp's own chips are All · Unread · Favourites · Groups. Groups do not
 * exist here and Favourites has no server field, so the row is what this inbox
 * can honestly filter on: everything, unread, the threads this agent holds, and
 * the ones they archived on this device.
 */
export const FILTERS = [
	{ id: 'all', label: 'All' },
	{ id: 'unread', label: 'Unread' },
	{ id: 'mine', label: 'Mine' },
	{ id: 'archived', label: 'Archived' },
];

export default function FilterChips({ value, onChange, counts = {}, show = {} }) {
	return (
		<HStack spacing="1.5" px="3" pb="2" overflowX="auto" role="tablist" aria-label="Filter chats">
			{FILTERS.filter((f) => show[f.id] !== false).map((f) => {
				const active = value === f.id;
				const count = counts[f.id];
				return (
					<Button
						key={f.id}
						role="tab"
						aria-selected={active}
						size="xs"
						h="28px"
						px="3"
						borderRadius="full"
						fontWeight="medium"
						flexShrink={0}
						bg={active ? 'wa.chipActive' : 'wa.chip'}
						color={active ? 'wa.chipActiveInk' : 'wa.inkMuted'}
						_hover={{ bg: active ? 'wa.chipActive' : 'wa.hover' }}
						_active={{ transform: 'scale(0.97)' }}
						transition="background 120ms ease, transform 80ms ease"
						onClick={() => onChange(f.id)}
					>
						{f.label}
						{count > 0 && f.id !== 'all' ? ` ${count}` : ''}
					</Button>
				);
			})}
		</HStack>
	);
}
